import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface PlatformConfig {
  platformName?: string;
  supportEmail?: string | null;
  termsVersion?: string;
  privacyVersion?: string;
  legalEntityName?: string;
  legalEffectiveDate?: string;
  icpFilingNumber?: string;
  icpFilingUrl?: string;
  logoUrl?: string | null;
  passwordPolicy?: {
    minLength: number;
    maxLength: number;
    compositionRequired: boolean;
  };
  passwordResetDelivery?: "EMAIL" | "ADMIN_HANDOFF" | "UNAVAILABLE";
}

export const fallbackPlatformName = "Liber Academy";

export function usePlatform() {
  const query = useQuery({
    queryKey: ["platform"],
    queryFn: () => api<PlatformConfig>("/platform"),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: 1,
  });
  const configuredName = query.data?.platformName?.trim();
  return {
    ...query,
    platformName: configuredName || fallbackPlatformName,
    supportEmail: query.data?.supportEmail?.trim() || null,
  };
}
